<template>
  <section class="card modal-card">
    <header class="bandeau-modal card-header"></header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('popupChangerEtatExpedition.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <error-msg-component
        :error="error"
        :messages="messages"
        :champsVide="champsVide"
        :messagesChampsVide="messagesChampsVide"
        @close="error = $event"
        title="general.problemOccurred"
        withEmplyFields
      />
      <section class="columns is-multiline">
        <b-field
          :label="$t('popupChangerEtatExpedition.adresseExpediteur')"
          class="column mgb-0 is-6"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <div class="mg-10px">
            <adresse-detail
              v-if="bonExpedition.adresseExpediteur"
              :adresse="bonExpedition.adresseExpediteur"
              classLigne="has-text-weight-bold">
            </adresse-detail>
          </div>
        </b-field>
        <b-field
          :label="$t('popupChangerEtatExpedition.adresseExpedition')"
          class="column mgb-0 is-6"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <div class="mg-10px">
            <adresse-detail
              v-if="bonExpedition.adresseExpedition"
              :adresse="bonExpedition.adresseExpedition"
              classLigne="has-text-weight-bold">
            </adresse-detail>
          </div>
        </b-field>
        <b-field
          :label="$t('popupChangerEtatExpedition.dateExpedition')"
          class="column mgb-0 is-4 obligatoire">
          <b-datepicker
            v-model="bonExpedition.dateBonExpedition"
            position="is-bottom-right"
            icon="calendar-today"
            nearby-selectable-month-days
            show-week-number editable>
          </b-datepicker>
        </b-field>
        <b-field
          :label="$t('popupChangerEtatExpedition.nombreElementColis')"
          class="column mgb-0 is-4 obligatoire">
          <b-input
            v-model.number="bonExpedition.nombreElementColis"
            :use-html5-validation="false"
            type="number" min="0" step="0.00001"/>
        </b-field>
        <b-field
          :label="$t('popupChangerEtatExpedition.poidsParColis')"
          class="column mgb-0 is-4 obligatoire">
          <b-input
            v-model.number="bonExpedition.poidsParColis"
            :use-html5-validation="false"
            type="number" min="0" step="0.00001"/>
        </b-field>
        <b-field
          :label="$t('popupChangerEtatExpedition.contactDestination')"
          class="column mgb-0 is-6 obligatoire">
          <b-autocomplete
            v-model="contactDestination"
            @input="getContactsDebounce"
            @select="actionContactSelect"
            :placeholder="$t('popupChangerEtatExpedition.contactDestination')"
            :data="contacts"
            :loading="isFetchingContact"
            field="nomPrenom"
            icon="magnify"
            open-on-focus>
            <template #empty>
              {{$t(`general.autocomplete.${!isFetchingContact ? 'noRslt' : 'search'}`)}}
            </template>
          </b-autocomplete>
        </b-field>
        <user-selector
          v-model="bonExpedition.contactExpediteurId"
          :label="$t('popupChangerEtatExpedition.contactExpediteur')"
          class="column mgb-0 is-6">
        </user-selector>
        <b-field
          :label="$t('popupChangerEtatExpedition.instructionDeLivraison')"
          class="column mgb-0 is-12">
          <b-input
            v-model="bonExpedition.instructionDeLivraison"
            type="textarea"
            rows="3">
          </b-input>
        </b-field>
      </section>
      <footer class="buttons mgt-20px">
        <qd-button
          @click="$parent.close()"
          type="is-light"
          class="btn-modal-annuler">
          {{$t('general.button.cancel')}}
        </qd-button>
        <qd-button
          @click="actionValider"
          :disabled="hasError"
          class="button is-addOrEdit">
          {{$t('general.button.valider')}}
        </qd-button>
      </footer>
    </div>
  </section>
</template>

<script>
import uniq from 'lodash/uniq';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { getAllWithTiers as getAllContactByTiers } from '@/api/contacts';
import { expedier } from '@/api/logistique/bonExpedition';
import adresseDetail from '@/components/general/adresseDetail';
import userSelector from '@/components/commun/user/userSelector';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import formatDateIso from '@/services/general/formatIsoDate';
import messageSuccess from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import getContactFullName from '@/services/contact/contactHelper';
import translate from '@/services/logistique/ordreTravail/expedition/translatorChangerEtatExpedition';
import { downloadPj, preValidation } from '@/services/logistique/ordreTravail/expedition/bonExpeditionService';
import genererDataBonExpedition from '@/services/logistique/ordreTravail/expedition/genererDataBonExpedition';
import { TIERS_TYPE_CLIENT } from '@/configuration/tiers/tiersConf';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import { BON_EXPEDITION } from '@/configuration/logistique/permissionsLogistiqueConf';
import { getAllByTiers } from '@/api/contactTiers/index';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'popUpChangerEtatExpedition',
  components: {
    userSelector,
    adresseDetail,
    errorMsgComponent,
  },
  props: {
    dataOtsExpeditions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      error: false,
      contacts: [],
      messages: [],
      champsVide: [],
      contactReceveurs: [],
      messagesChampsVide: [],
      contactDestination: null,
      isFetchingContact: false,
      bonExpedition: genererDataBonExpedition(),
      constantes: {
        TYPE_PDF,
        BON_EXPEDITION,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    otExpeditions() {
      return this.dataOtsExpeditions[0]?.otExpeditions || [];
    },
    adresseLieuExpedition() {
      return this.dataOtsExpeditions[0]?.adresse || null;
    },
    hasError() {
      return this.dataOtsExpeditions.length > 1;
    },
  },
  methods: {
    async getContacts(search) {
      if (!search) this.actionContactSelect();
      this.isFetchingContact = true;
      this.contacts = [];
      const tiersId = uniq(this.otExpeditions.flatMap(ote => [
        ote.lieuDeLivraisonId,
        ote.lieuDeStockageId,
      ]));
      const query = {
        tiersId,
        auto: search,
        archive: false,
        type: TIERS_TYPE_CLIENT,
        societeId: this.societeActive.id,
      };
      try {
        const contacts = (await getAllContactByTiers({ query })).data.result.items.map(item => ({
          ...item,
          nomPrenom: getContactFullName(item),
        }));

        const contactTiers = (await getAllByTiers(tiersId)).data.result.items.map(item => ({
          ...item,
          nomPrenom: getContactFullName(item),
        }));

        const contactReceveursFilter = this.contactReceveurs
          .filter(c => !search || c.nomPrenom.toLowerCase().includes(search.toLowerCase()))
          .filter(c => !contacts.some(ct => ct.id === c.id));
        this.contacts = [...contacts, ...contactTiers, ...contactReceveursFilter];
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingContact = false;
      }
    },
    getContactsDebounce: debounce(async function getContacts(search) {
      await this.getContacts(search);
    }, 300),
    actionContactSelect(opt) {
      this.contactDestination = opt?.nomPrenom || null;
      this.bonExpedition.contactDestinataireId = opt?.id || null;
      this.bonExpedition.nomContactDestinataire = opt?.nom || null;
      this.bonExpedition.emailContactDestinataire = opt?.email || null;
      this.bonExpedition.prenomContactDestinataire = opt?.prenom || null;
      this.bonExpedition.numTelephoneContactDestinataire = opt?.telephone || null;
    },
    initBonExpedition() {
      this.bonExpedition.clientId = this.dataOtsExpeditions[0]?.id;
      this.bonExpedition.societeId = this.societeActive?.id || null;
      this.bonExpedition.adresseExpediteur = this.societeActive?.adresse || null;
      this.bonExpedition.emailExpediteur = this.societeActive?.emailPrincipal || null;
      this.bonExpedition.adresseExpedition = this.dataOtsExpeditions[0]?.adresse || null;
      this.bonExpedition.nombreElementColis = this.otExpeditions
        .reduce((acc, ot) => acc + ot.quantite, 0);
    },
    async actionValider() {
      const loadingComponent = this.$buefy.loading.open();
      this.error = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.popUpPrevention = false;
      const otIds = this.otExpeditions.map(ot => ot.id);
      try {
        const payload = cloneDeep(this.bonExpedition);
        payload.dateBonExpedition = formatDateIso(payload.dateBonExpedition);
        preValidation(payload);
        const bonExpedition = (await expedier({
          bonExpeditionCreate: payload,
          otIds: otIds,
        })).data.result;
        await downloadPj(bonExpedition);
        messageSuccess(this.$i18n.t('popupChangerEtatExpedition.msgActionSuccess'));
        this.$parent.close();
        this.$emit('refresh');
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    async getContactsReceveurs() {
      this.contactReceveurs = [];
      const query = {
        ids: uniq(this.otExpeditions.map(ote => ote.contactReceveurId).filter(Boolean)),
        archive: false,
        type: TIERS_TYPE_CLIENT,
        societeId: this.societeActive.id,
      };
      if (query.ids.length === 0) return;
      const contacts = (await getAllContactByTiers({ query })).data.result.items.map(item => ({
        ...item,
        nomPrenom: getContactFullName(item),
      }));
      this.contactReceveurs = contacts;
    },
    validationDataOtsExpeditions() {
      this.messages = [];
      if (this.dataOtsExpeditions.length > 1) {
        this.messages.push({
          message: 'popupChangerEtatExpedition.msgErreurMemeLieuExpedition',
        });
      }
      if (this.messages.length) this.error = true;
    },
  },
  async mounted() {
    this.validationDataOtsExpeditions();
    if (this.error) return;
    this.initBonExpedition();
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.getContactsReceveurs();
      await this.getContacts();
      if (this.contactReceveurs.length === 1) this.actionContactSelect(this.contactReceveurs[0]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
